/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityServiceArea } from './FacilityServiceArea';
import {
    FacilityServiceAreaFromJSON,
    FacilityServiceAreaFromJSONTyped,
    FacilityServiceAreaToJSON,
} from './FacilityServiceArea';

/**
 * 
 * @export
 * @interface FindAllFacilityServiceAreasResponse
 */
export interface FindAllFacilityServiceAreasResponse {
    /**
     * 
     * @type {Array<FacilityServiceArea>}
     * @memberof FindAllFacilityServiceAreasResponse
     */
    data: Array<FacilityServiceArea>;
    /**
     * 
     * @type {number}
     * @memberof FindAllFacilityServiceAreasResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllFacilityServiceAreasResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllFacilityServiceAreasResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllFacilityServiceAreasResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllFacilityServiceAreasResponse interface.
 */
export function instanceOfFindAllFacilityServiceAreasResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllFacilityServiceAreasResponseFromJSON(json: any): FindAllFacilityServiceAreasResponse {
    return FindAllFacilityServiceAreasResponseFromJSONTyped(json, false);
}

export function FindAllFacilityServiceAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFacilityServiceAreasResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FacilityServiceAreaFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllFacilityServiceAreasResponseToJSON(value?: FindAllFacilityServiceAreasResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(FacilityServiceAreaToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

